(() => {
    "use strict";
    const safe = fn => {
            try {
                return fn()
            } catch (e) {
                console.error("[KYMEE Facets]", e)
            }
        },
        debounce = (fn, delay = 250) => {
            let t;
            return (...args) => {
                clearTimeout(t), t = setTimeout(() => fn(...args), delay)
            }
        };
    "requestIdleCallback" in window || (window.requestIdleCallback = cb => setTimeout(() => cb({
        didTimeout: !1,
        timeRemaining: () => 16
    }), 1), window.cancelIdleCallback = id => clearTimeout(id));
    const raf2 = fn => requestAnimationFrame(() => requestAnimationFrame(fn)),
        SEL = {
            gridContainer: "#ProductGridContainer",
            desktopForm: "#FacetFiltersForm",
            mobileForm: "#FacetFiltersFormMobile",
            activeDesktop: ".active-facets-desktop",
            activeMobile: ".active-facets-mobile",
            count: "#ProductCount",
            countDesktop: "#ProductCountDesktop",
            spinner: ".loading__spinner",
            mobileDrawerDetails: ".mobile-facets__disclosure",
            mobileInner: ".mobile-facets__inner",
            desktopDetails: ".facets__wrapper details.js-filter, details.facets__disclosure-vertical.js-filter, details.facets__disclosure.js-filter",
            mobileDetails: ".mobile-facets__details.js-filter",
            sortOverlay: "#mob_sort_by_overlay",
            sortOption: ".facet-sort-option",
            sortSelect: "select[name='sort_by']",
            sortOpenButton: ".mobile-facets__sort",
            sortCloseButton: "#close-sort-by"
        },
        STATE = {
            params: window.location.search.replace(/^\?/, ""),
            openDesktop: new Set,
            openMobile: new Set,
            mobileDrawerOpen: !1,
            abort: null,
            reqId: 0,
            cache: new Map,
            cacheLimit: 15
        },
        cacheSet = (k, v) => {
            if (STATE.cache.set(k, v), STATE.cache.size > STATE.cacheLimit) {
                const firstKey = STATE.cache.keys().next().value;
                STATE.cache.delete(firstKey)
            }
        },
        keyOf = el => el?.id || el?.getAttribute?.("data-index") || null,
        captureOpenState = () => {
            STATE.openDesktop.clear(), STATE.openMobile.clear(), document.querySelectorAll(SEL.desktopDetails).forEach(d => {
                const k = keyOf(d);
                k && d.open && STATE.openDesktop.add(k)
            }), document.querySelectorAll(SEL.mobileDetails).forEach(d => {
                const k = keyOf(d);
                k && d.open && STATE.openMobile.add(k)
            });
            const drawer = document.querySelector(SEL.mobileDrawerDetails);
            STATE.mobileDrawerOpen = !!drawer?.open
        },
        restoreOpenState = () => {
            document.querySelectorAll(SEL.desktopDetails).forEach(d => {
                const k = keyOf(d);
                k && STATE.openDesktop.has(k) && (d.open = !0)
            }), document.querySelectorAll(SEL.mobileDetails).forEach(d => {
                const k = keyOf(d);
                k && STATE.openMobile.has(k) && (d.open = !0)
            });
            const drawer = document.querySelector(SEL.mobileDrawerDetails);
            drawer && STATE.mobileDrawerOpen && (drawer.open = !0)
        },
        getSections = () => {
            const sections = [],
                gridSection = document.getElementById("product-grid")?.dataset?.id;
            gridSection && sections.push(gridSection);
            const filtersSection = document.querySelector("#main-collection-filters")?.dataset?.id || document.querySelector("[data-facets-section-id]")?.getAttribute("data-facets-section-id") || document.querySelector(".facets-container")?.closest("[data-section-id]")?.getAttribute("data-section-id") || document.querySelector("facet-filters-form")?.closest("[data-section-id]")?.getAttribute("data-section-id");
            return filtersSection && filtersSection !== gridSection && sections.push(filtersSection), [...new Set(sections)].filter(Boolean)
        },
        patchHTML = doc => {
            const freshGrid = doc.querySelector(SEL.gridContainer),
                curGrid = document.querySelector(SEL.gridContainer);
            freshGrid && curGrid && (curGrid.innerHTML = freshGrid.innerHTML);
            const freshDesktop = doc.querySelector(SEL.desktopForm),
                curDesktop = document.querySelector(SEL.desktopForm);
            freshDesktop && curDesktop && (curDesktop.innerHTML = freshDesktop.innerHTML);
            const freshMobile = doc.querySelector(SEL.mobileForm),
                curMobile = document.querySelector(SEL.mobileForm);
            freshMobile && curMobile && (curMobile.innerHTML = freshMobile.innerHTML), [SEL.activeDesktop, SEL.activeMobile, SEL.count, SEL.countDesktop].forEach(sel => {
                const f = doc.querySelector(sel),
                    c = document.querySelector(sel);
                f && c && (c.innerHTML = f.innerHTML)
            })
        },
        setLoading = on => {
            const grid = document.querySelector(SEL.gridContainer);
            on ? grid?.classList.add("loading") : grid?.classList.remove("loading"), document.querySelectorAll(SEL.spinner).forEach(s => {
                on ? s.classList.remove("hidden") : s.classList.add("hidden")
            })
        },
        serializeForm = form => {
            if (!form) return "";
            const fd = new FormData(form);
            return new URLSearchParams(fd).toString()
        },
        collectParams = () => Array.from(document.querySelectorAll("facet-filters-form form")).map(serializeForm).filter(Boolean).join("&"),
        updateURL = params => {
            const url = `${location.pathname}${params ? "?" + params : ""}`;
            history.pushState({
                searchParams: params
            }, "", url)
        },
        fetchSection = async (sectionId, params, signal) => {
            const url = `${location.pathname}?section_id=${sectionId}${params ? "&" + params : ""}`;
            if (STATE.cache.has(url)) return STATE.cache.get(url);
            const html = await (await fetch(url, {
                signal,
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                },
                credentials: "same-origin"
            })).text();
            return cacheSet(url, html), html
        }, render = async (params, {
            updateHistory = !0
        } = {}) => {
            params = (params || "").trim(), captureOpenState(), STATE.abort && safe(() => STATE.abort.abort()), STATE.abort = new AbortController;
            const signal = STATE.abort.signal,
                myReq = ++STATE.reqId;
            STATE.params = params, setLoading(!0);
            const sections = getSections();
            if (!sections.length) {
                setLoading(!1);
                return
            }
            try {
                const htmlList = await Promise.all(sections.map(sid => fetchSection(sid, params, signal)));
                if (myReq !== STATE.reqId) return;
                htmlList.forEach(html => {
                    const doc = new DOMParser().parseFromString(html, "text/html");
                    patchHTML(doc)
                }), restoreOpenState(), raf2(() => {
                    document.body.offsetHeight, raf2(() => {
                        setLoading(!1), updateHistory && updateURL(params), safe(() => {
                            const ff = document.querySelector("facet-filters-form");
                            ff && customElements.upgrade(ff), document.querySelectorAll("price-range, facet-remove").forEach(el => {
                                try {
                                    customElements.upgrade(el)
                                } catch {}
                            })
                        }), document.dispatchEvent(new CustomEvent("collection:updated")), document.dispatchEvent(new CustomEvent("kymee:collection:reset", {
                            detail: {
                                source: "facets"
                            }
                        }))
                    })
                })
            } catch (e) {
                if (e?.name === "AbortError") return;
                console.error("[KYMEE Facets] render error:", e), setLoading(!1)
            }
        };
    class FacetFiltersForm extends HTMLElement {
        connectedCallback() {
            if (this.__bound) return;
            this.__bound = !0;
            const form = this.querySelector("form");
            if (!form) return;
            const onChange = debounce(ev => {
                safe(() => ev?.preventDefault?.()), render(collectParams(), {
                    updateHistory: !0
                })
            }, 240);
            form.addEventListener("input", onChange), form.addEventListener("change", onChange)
        }
        onActiveFilterClick(params) {
            render((params || "").trim(), {
                updateHistory: !0
            })
        }
    }
    class FacetRemove extends HTMLElement {
        connectedCallback() {
            if (this.__bound) return;
            this.__bound = !0;
            const link = this.querySelector("a");
            if (!link) return;
            link.setAttribute("role", "button");
            const run = e => {
                safe(() => e.preventDefault());
                const params = (link.href.split("?")[1] || "").trim();
                document.querySelector("facet-filters-form")?.onActiveFilterClick?.(params)
            };
            link.addEventListener("click", run), link.addEventListener("keyup", e => {
                (e.key === " " || e.code === "Space") && run(e)
            })
        }
    }
    class PriceRange extends HTMLElement {
        connectedCallback() {
            this.__bound || (this.__bound = !0, this.textMin = this.querySelector(".price-input-min"), this.textMax = this.querySelector(".price-input-max"), this.rangeMin = this.querySelector(".range-min"), this.rangeMax = this.querySelector(".range-max"), this.track = this.querySelector(".price-slider-connect"), this.minLabel = this.querySelector(".min-range-price"), this.maxLabel = this.querySelector(".max-range-price"), !(!this.textMin || !this.textMax || !this.rangeMin || !this.rangeMax || !this.track) && (this._lock = !1, this._queued = !1, this.rangeMin.addEventListener("input", () => this.onSlider()), this.rangeMax.addEventListener("input", () => this.onSlider()), this.textMin.addEventListener("change", () => this.onText()), this.textMax.addEventListener("change", () => this.onText()), this.syncFromInputs(), this.updateVisuals()))
        }
        maxCap() {
            const v = parseInt(this.rangeMax.getAttribute("max") || "0", 10);
            return Number.isFinite(v) && v > 0 ? v : 1
        }
        clamp(min, max) {
            const cap = this.maxCap();
            min = Math.max(0, Math.min(min, cap)), max = Math.max(0, Math.min(max, cap)), max < min && (max = min);
            const GAP = 100;
            return max - min < GAP && (max = Math.min(cap, min + GAP)), {
                min,
                max
            }
        }
        syncFromInputs() {
            const cap = this.maxCap(),
                rawMin = (this.textMin.value || "").replace(/,/g, ""),
                rawMax = (this.textMax.value || "").replace(/,/g, "");
            let min = parseInt(rawMin || "0", 10),
                max = parseInt(rawMax || String(cap), 10);
            Number.isFinite(min) || (min = 0), Number.isFinite(max) || (max = cap), {
                min,
                max
            } = this.clamp(min, max), this.rangeMin.value = String(min), this.rangeMax.value = String(max)
        }
        updateVisuals() {
            const cap = this.maxCap(),
                min = parseInt(this.rangeMin.value || "0", 10),
                max = parseInt(this.rangeMax.value || String(cap), 10),
                p1 = min / cap * 100,
                p2 = max / cap * 100;
            this.track.style.left = p1 + "%", this.track.style.width = p2 - p1 + "%", this.minLabel && (this.minLabel.textContent = `\u20B9 ${min}`), this.maxLabel && (this.maxLabel.textContent = `\u20B9 ${max}`)
        }
        submitOnce() {
            this._queued || (this._queued = !0, requestAnimationFrame(() => {
                this._queued = !1, safe(() => this.textMin.dispatchEvent(new Event("change", {
                    bubbles: !0
                }))), safe(() => this.textMax.dispatchEvent(new Event("change", {
                    bubbles: !0
                })))
            }))
        }
        onSlider() {
            if (this._lock) return;
            this._lock = !0;
            let min = parseInt(this.rangeMin.value || "0", 10),
                max = parseInt(this.rangeMax.value || String(this.maxCap()), 10);
            Number.isFinite(min) || (min = 0), Number.isFinite(max) || (max = this.maxCap()), {
                min,
                max
            } = this.clamp(min, max), this.rangeMin.value = String(min), this.rangeMax.value = String(max), this.textMin.value = String(min), this.textMax.value = String(max), this.updateVisuals(), this.submitOnce(), requestAnimationFrame(() => this._lock = !1)
        }
        onText() {
            if (this._lock) return;
            this._lock = !0;
            const cap = this.maxCap(),
                rawMin = (this.textMin.value || "").replace(/,/g, ""),
                rawMax = (this.textMax.value || "").replace(/,/g, "");
            if (!rawMin && !rawMax) {
                this.rangeMin.value = "0", this.rangeMax.value = String(cap), this.updateVisuals(), this.submitOnce(), requestAnimationFrame(() => this._lock = !1);
                return
            }
            let min = parseInt(rawMin || "0", 10),
                max = parseInt(rawMax || String(cap), 10);
            Number.isFinite(min) || (min = 0), Number.isFinite(max) || (max = cap), {
                min,
                max
            } = this.clamp(min, max), this.rangeMin.value = String(min), this.rangeMax.value = String(max), this.textMin.value = rawMin ? String(min) : "", this.textMax.value = rawMax ? String(max) : "", this.updateVisuals(), this.submitOnce(), requestAnimationFrame(() => this._lock = !1)
        }
    }
    const bindDelegatesOnce = () => {
            window.__kymeeFacetsBound || (window.__kymeeFacetsBound = !0, document.addEventListener("click", e => {
                const a = e.target.closest(".active-facets a, .active-facets__clear a, .mobile-facets__clear");
                if (!a || !a.href || !a.href.includes("?")) return;
                e.preventDefault();
                const params = (a.href.split("?")[1] || "").trim(),
                    ff = document.querySelector("facet-filters-form");
                ff?.onActiveFilterClick ? ff.onActiveFilterClick(params) : window.location.href = a.href
            }), window.addEventListener("popstate", event => {
                const params = event.state?.searchParams ?? window.location.search.replace(/^\?/, "");
                params !== STATE.params && render(params, {
                    updateHistory: !1
                })
            }))
        },
        bindSortOverlay = () => {
            const overlay = document.querySelector(SEL.sortOverlay);
            if (!overlay || overlay.__bound) return;
            overlay.__bound = !0;
            const select = document.querySelector(SEL.sortSelect),
                closeBtn = document.querySelector(SEL.sortCloseButton),
                openBtn = document.querySelector(SEL.sortOpenButton),
                mobileOnly = window.matchMedia("(max-width: 749px)"),
                open = () => {
                    mobileOnly.matches && (overlay.style.display = "flex", requestAnimationFrame(() => overlay.classList.add("visible")), document.body.style.overflow = "hidden")
                },
                close = () => {
                    overlay.classList.remove("visible"), setTimeout(() => {
                        overlay.style.display = "none", document.body.style.overflow = ""
                    }, 250)
                };
            openBtn?.addEventListener("click", e => {
                e.preventDefault(), open()
            }), closeBtn?.addEventListener("click", e => {
                e.preventDefault(), close()
            }), overlay.addEventListener("click", e => {
                e.target === overlay && close()
            }), overlay.querySelectorAll(SEL.sortOption).forEach(opt => {
                opt.addEventListener("click", e => {
                    if (e.preventDefault(), !mobileOnly.matches) return;
                    const value = opt.dataset.value;
                    value && (select && (select.value = value), overlay.querySelectorAll(SEL.sortOption).forEach(o => o.classList.remove("selected")), opt.classList.add("selected"), render(collectParams(), {
                        updateHistory: !0
                    }), close())
                })
            })
        },
        defineSafely = (name, klass) => {
            customElements.get(name) || customElements.define(name, klass)
        };
    safe(() => {
        defineSafely("facet-filters-form", FacetFiltersForm), defineSafely("facet-remove", FacetRemove), defineSafely("price-range", PriceRange), bindDelegatesOnce(), bindSortOverlay(), document.addEventListener("collection:updated", () => {
            requestIdleCallback(bindSortOverlay, {
                timeout: 300
            })
        })
    })
})();
//# sourceMappingURL=/cdn/shop/t/114/assets/kymee-filters.js.map?v=19167261895322397831770035669